var map = {
	"./A.png": 396,
	"./B.png": 804,
	"./C.png": 432,
	"./D.png": 765,
	"./E.png": 234,
	"./F.png": 849,
	"./G.png": 884,
	"./H.png": 653,
	"./I.png": 890,
	"./J.png": 462,
	"./K.png": 888,
	"./L.png": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;